<template>
  <div class="grey lighten-4 fill-height d-flex justify-center align-start">
    <v-card max-width="800px" class="mt-10">
      <v-card-title>
        Completar Cadastro
      </v-card-title>
      <v-card-subtitle>
        Mais alguns passos para você finalizar seu cadastro
      </v-card-subtitle>
      <v-form ref="registerForm" @submit.prevent="sendRegister()">
        <v-card-text>
          <v-text-field
            v-model="register.name"
            label="Razão Social *"
            filled
            hide-details="auto"
            class="mb-2"
            :rules="[$rules.required]"
            :disabled="loadingSave"
          />
          <v-text-field
            v-model="register.cnpj"
            label="CNPJ *"
            filled
            hide-details="auto"
            class="mb-2"
            :disabled="loadingSave"
            :rules="[$rules.required, $rules.cnpj]"
            v-mask="'##.###.###/####-##'"
          />
          <v-text-field
            v-model="register.email"
            label="E-Mail Corporativo *"
            filled
            hide-details="auto"
            class="mb-2"
            :rules="[$rules.required, $rules.email]"
            :disabled="loadingSave"
          />
          <v-text-field
            v-model="register.phone"
            label="Telefone *"
            filled
            hide-details="auto"
            class="mb-2"
            v-mask="['(##) ####-####', '(##) #####-####']"
            placeholder="(00) 00000-0000"
            :rules="[$rules.required, $rules.phone]"
            :disabled="loadingSave"
          />
          <v-text-field
            v-model="register.password"
            label="Senha *"
            filled
            hide-details="auto"
            class="mb-2"
            :rules="[$rules.required, $rules.passwordMin]"
            :disabled="loadingSave"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
          />
          <v-text-field
            label="Confirmação da Senha *"
            filled
            hide-details="auto"
            class="mb-2"
            :disabled="loadingSave"
            :rules="[
              $rules.required,
              $rules.passwordMin,
              $rules.equalPassword(() => register.password),
            ]"
            :append-icon="confirmRepeat ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="confirmRepeat = !confirmRepeat"
            :type="confirmRepeat ? 'text' : 'password'"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <div class="d-flex align-center">
            <div class="mr-4">
              <v-checkbox
                :disabled="loadingSave"
                label="Concordo com os Termos e Condições de Uso"
                hide-details="auto"
                class="my-0"
                :rules="[(val) => !!val || 'Você deve aceitar para continuar']"
              />
              <v-checkbox
                :disabled="loadingSave"
                label="Concordo com a Política de Privacidade"
                hide-details="auto"
                class="my-0"
                :rules="[(val) => !!val || 'Você deve aceitar para continuar']"
              />
            </div>
            <v-btn
              :loading="loadingSave"
              color="success"
              type="submit"
              large
            >
              Criar Conta
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Register",

  data: () => ({
    loading: false,
    loadingSave: false,
    confirmPassword: false,
    confirmRepeat: false,
    showPassword: false,
    value: false,
    register: {
      name: "",
      email: "",
      cnpj: "",
      phone: "",
      password: "",
    },
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      this.loadingSave = true;
      this.$axios.get(`/user/${this.$route.params.email}`)
      .then((response) => {
        this.register = response.data
        this.$refs.registerForm.resetValidation();
      })
      .catch((error) => {
        if(error.response){
          if(error.response.status == 401){
            this.$router.replace({ name: 'login'})
            this.$showMessage("success", "Seu Cadastro já Foi Completado")
            return;
          }
          if(error.response.status == 404){
            this.$router.replace({ name: 'landing'})
            this.$showMessage("warning", "Nenhum convite foi criado com esse e-mail")
            return;
          }
        }
        this.$showMessage("error", "Ocorreu um erro inesperado")
      })
      .finally(() => {
        this.loadingSave = false;
      })
        
    },
    sendRegister() {
      if (!this.$refs.registerForm.validate()){
        this.$showMessage("error", "Preencha todos os campos corretamente");
      } else {
        this.loadingSave = true;
        this.$axios
          .put("/complete-registration", this.register)
          .then((reponse) => {
            this.$showMessage("success", "Cadastro completado com sucesso");
            this.$router.replace({
              name: "app",
            });
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 400) {
                this.$showMessage(
                  "warning",
                  "Usuário com esse email já cadastrado"
                );
                return;
              }
              if (error.response.status == 409) {
                this.$showMessage("warning", "CNPJ já cadastrado");
                return;
              }
              if (error.response.status == 401) {
                this.$showMessage("warning", "Os números do CNPJ são inválidos");
                return;
              }
            }
            this.$showMessage("error", "Falha Inesperada no Cadastro");
            
          })
          .finally(() => {
            this.loadingSave = false;
          });
      }
    },
  },
};
</script>
